module.exports = require('./shuffle').default;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/